import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, ListItemAvatar } from '@material-ui/core';
import Avatar from 'sharedComponents/Avatar';
import { getInitials, getFullUserName, capitalize } from 'utils';
import ContactsList from 'sharedComponents/ContactsList';

const EMAIL = 'email';
const PHONE = 'phone';

const ClientListItemMessage = ({ classes, client, customClientClickAction, contactType }) => {
  const onItemClickHandler = (profileId, fullName, contact, clientData) => () =>
    contact &&
    customClientClickAction({
      profileId,
      fullName,
      contact,
      clientData,
    });

  const onContactClickHandler = (profileId, fullName, clientData) => (contact) =>
    customClientClickAction({
      profileId,
      fullName,
      contact,
      clientData,
    });

  const contactsPropName = contactType === PHONE ? 'phoneNumbers' : 'emails';
  let contacts = client[contactsPropName] || [];

  if (contactType === PHONE) {
    contacts = contacts.map(({ type, number = '' }) => `${number}${type ? ` (${capitalize(type)})` : ''}`);
  }

  const [isContactListExpanded, onContactListExpanded] = React.useState(false);

  const fullName = getFullUserName(client);
  const initials = !client.image ? getInitials(fullName) : null;
  const { profileId, image } = client;
  const [defaultContact] = contacts;

  const secondary = (
    <ContactsList
      fixedHeight
      data-testid="contacts-list"
      items={contacts}
      onExpand={onContactListExpanded}
      onItemClick={onContactClickHandler(profileId, fullName, client)}
    />
  );

  const hideName = isContactListExpanded && contacts.length > 1;

  return (
    <ListItem
      disableGutters
      disabled={!defaultContact}
      data-testid="client-list-item"
      classes={{ root: classes.listItem }}
      key={profileId}
      onClick={onItemClickHandler(client.profileId, fullName, defaultContact, client)}
    >
      <ListItemAvatar classes={{ root: classes.avatarRoot }}>
        <Avatar src={image || null} classes={{ colorDefault: classes.avatarColor }}>
          {initials}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        classes={{ root: hideName ? classes.nameHidden : classes.name }}
        primary={fullName}
        secondary={secondary}
        secondaryTypographyProps={{
          component: 'div',
        }}
      />
    </ListItem>
  );
};

ClientListItemMessage.propTypes = {
  classes: PropTypes.shape({}),
  client: PropTypes.shape({
    profileId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumbers: PropTypes.arrayOf(PropTypes.object),
    image: PropTypes.string,
  }),
  contactType: PropTypes.oneOf([EMAIL, PHONE]),
};

ClientListItemMessage.defaultProps = {
  classes: {},
  client: {},
  contactType: EMAIL,
};

export default ClientListItemMessage;
